import { Navigate } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { LogoutLink } from "../auth/LogoutLink";
import { selectUser } from "../reducers/userSlice";

export const PrivateRoute = ({ children }) => {
  const user = useSelector(selectUser);
  if (typeof user !== `undefined` && user !== null) {
    var fecha_login = new Date(user.user["fecha_login"]).getTime();
    var fecha_actual    = new Date().getTime();

    var diff = fecha_actual - fecha_login;
    console.log('horas desde login',(diff/(1000*60*60)));
    if((diff/(1000*60*60))>3 ){ //cerrar sesión a las 3 horas
      return <Navigate to={`/login`}></Navigate>;
    }else{
      return children;
    }
    

    
  } else {
    
    return <Navigate to={`/login`}></Navigate>;
  }
};
